import React, { useState } from 'react';
import './PizzaPartModal.scss';
import FormattedPrice from "../components/FormattedPrice";

const PizzaPartModal = ({ closeModal,
                        onClose,
                        onOk,
                        onDelete,
                        supplement
                      }) => {
  const [currentPart, setCurrentPart] = useState(supplement.pizza_item_part);
  const onSelectPart = (part) => {
    if (part === "0000000") {
      if (onDelete) {
        onDelete(supplement);
      }

      closeModal();
      return;
    }

    setCurrentPart(part);
    const newSupplement = Object.assign({}, supplement);
    newSupplement.pizza_item_part = part;
    onOk(newSupplement);
    closeModal();
  };

  return (
    <div className='pizza-part-modal-content'>
      <div className='pizza-part-modal-body'>
        <div className={'parts'}>
          <div
            className={`part part-no ${currentPart === '0000000' ? 'selected' : ''}`}
            onClick={ ()=>{ onSelectPart('0000000') } }
          >
            No
          </div>
          <div
            className={`part part-full ${currentPart === '1000000' ? 'selected' : ''}`}
            onClick={ ()=>{ onSelectPart('1000000') } }
          >
            <div className={'part-circle'}>&nbsp;</div>
            <FormattedPrice price={ supplement.web_price } />
          </div>
          <div
            className={`part part-half-left ${currentPart === '0100000' ? 'selected' : ''}`}
            onClick={ ()=>{ onSelectPart('0100000') } }
          >
            <div className={'part-circle'}>&nbsp;</div>
            <FormattedPrice price={ supplement.web_price * 0.5 } />
          </div>
          <div
            className={`part part-half-right ${currentPart === '0010000' ? 'selected' : ''}`}
            onClick={ ()=>{ onSelectPart('0010000') } }
          >
            <div className={'part-circle'}>&nbsp;</div>
            <FormattedPrice price={ supplement.web_price * 0.5 } />
          </div>
          <div
              className={`part part-quarter-left-top ${currentPart === '0001000' ? 'selected' : ''}`}
            onClick={ ()=>{ onSelectPart('0001000') } }
          >
            <div className={'part-circle'}>&nbsp;</div>
            <FormattedPrice price={ supplement.web_price * 0.25 } />
          </div>
          <div
            className={`part part-quarter-right-top ${currentPart === '0000100' ? 'selected' : ''}`}
            onClick={ ()=>{ onSelectPart('0000100') } }
          >
            <div className={'part-circle'}>&nbsp;</div>
            <FormattedPrice price={ supplement.web_price * 0.25 } />
          </div>
          <div
            className={`part part-quarter-left-bottom ${currentPart === '0000010' ? 'selected' : ''}`}
            onClick={ ()=>{ onSelectPart('0000010') } }
          >
            <div className={'part-circle'}>&nbsp;</div>
            <FormattedPrice price={ supplement.web_price * 0.25 } />
          </div>
          <div
            className={`part part-quarter-right-bottom ${currentPart === '0000001' ? 'selected' : ''}`}
            onClick={ ()=>{ onSelectPart('0000001') } }
          >
            <div className={'part-circle'}>&nbsp;</div>
            <FormattedPrice price={ supplement.web_price * 0.25 } />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PizzaPartModal;
